var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishlist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.183 18.471l-2.52 2.66a1.56 1.56 0 01-2.292-.01l-2.54-2.679c-.894-.944-1.114-2.437-.428-3.547.943-1.525 2.928-1.673 4.09-.446 1.153-1.217 3.14-1.055 4.093.479.695 1.116.485 2.605-.403 3.543z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 21.628H17a2 2 0 002-2v-9.586a1 1 0 00-.293-.707L13.293 3.92a1 1 0 00-.707-.293H7a2 2 0 00-2 2v5.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgWishlist;